var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBevoFett48(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.9,26.1l-0.8-0.9c-0.2-0.2-0.6-0.3-0.9-0.1l-2,1.1c-0.3,0.2-0.3,0.5-0.1,0.7l0.8,0.9c0.2,0.2,0.6,0.3,0.9,0.1l2-1.1 C29,26.6,29.1,26.3,28.9,26.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.8,22.7c-0.5-0.9-2.6-5.4-3.8-7.6c-0.3-0.5,0.1-1,0.1-1L17,19.2c0,0,0.7-0.3,1.4,0.6c0.8,1,5.4,5.7,5.4,5.7 s0.6,1,1.4,0.5c0.8-0.6,2.3-1.6,2.3-1.6S28.4,23.7,27.8,22.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,34h-9c-0.3,0-0.5,0.2-0.5,0.5v1c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5v-1C33,34.2,32.8,34,32.5,34z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.9,29.6l-2-2.4c-0.2-0.2-0.5-0.3-0.8-0.1l-0.9,0.6c-0.2,0.2-0.3,0.5-0.1,0.7l0.9,1.2c0.2,0.2,0.5,0.4,0.8,0.4l1.9,0 C31,30,31.1,29.8,30.9,29.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.9,13.1l-0.7-0.9c-0.2-0.2-0.5-0.3-0.7-0.1l-7.3,5.2c-0.2,0.2-0.3,0.5-0.1,0.7l0.7,0.9c0.2,0.2,0.5,0.3,0.7,0.1 l7.3-5.2C24,13.6,24.1,13.3,23.9,13.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBevoFett48);
export default __webpack_public_path__ + "static/media/ic_bevo_fett_48.1e30ccc4f23287861636609ac43a5e34.svg";
export { ForwardRef as ReactComponent };